var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transactions"},[_c('v-row',[_c('v-col',[_c('breadcrumb',{attrs:{"items":_vm.breadcrumbs}})],1)],1),_c('payments-table',{attrs:{"transaction-url":_vm.transactionUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }